import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faTasks,
  faUsers,
  faUserTie,
  faNetworkWired,
  faChartBar,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';

function Sidebar({ isOpen, toggleSidebar }) {
  const navigate = useNavigate();

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        {isOpen && <span className="header-text">CSC Tracking</span>}
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>
      </div>
      <ul className="sidebar-menu">
        <li onClick={() => navigate('/dashboard')}>
          <FontAwesomeIcon icon={faHome} />
          <span className="menu-text">Dashboard</span>
        </li>
        <li onClick={() => navigate('/processos')}>
          <FontAwesomeIcon icon={faTasks} />
          <span className="menu-text">Processos</span>
        </li>
        <li onClick={() => navigate('/tiposervicos')}>
          <FontAwesomeIcon icon={faNetworkWired} />
          <span className="menu-text">Tipo de Serviços</span>
        </li>
        <li onClick={() => navigate('/e2e')}>
          <FontAwesomeIcon icon={faChartBar} />
          <span className="menu-text">E2E</span>
        </li>
        <li onClick={() => navigate('/gestores')}>
          <FontAwesomeIcon icon={faUserTie} />
          <span className="menu-text">Gestores</span>
        </li>
        <li onClick={() => navigate('/analistas')}>
          <FontAwesomeIcon icon={faUsers} />
          <span className="menu-text">Analistas</span>
        </li>
      </ul>
      <button className="logout-button" onClick={() => navigate('/')}>
        <FontAwesomeIcon icon={faSignOutAlt} />
        {isOpen && <span className="menu-text">‎ Logout</span>}
      </button>
    </aside>
  );
}

export default Sidebar;
